import { instance } from '../../config/intercepter';

export const getServiceFlowtFn = async () => {
  const response = await instance.get(`api/getflows`);
  return response.data;
};

export const getServiceAvailabilityFn = async (payload) => {
  const response = await instance.get(
    `api/serviceavailability/${payload.flowId}/${payload.garageCode}`
  );
  return response.data;
};

export const initiateServiceFn = async (payload) => {
  const response = await instance.post(`api/serviceinitiate`,payload);
  return response.data;
};

export const wantBodyWorkFn = async (payload) => {
  const response = await instance.post(`api/servicesubmitstep/${payload.flowId}/wantBodyWork`, { wantBodyWork: payload.wantBodyWork });
  return response.data
}

export const tyreWantChangeFn = async (payload) => {
  const response = await instance.post(`api/servicesubmitstep/${payload.flowId}/tyreWantChange`, { tyreWantChange: payload.tyreWantChange });
  return response.data
}

export const serviceEndpointFn = async (payload) => {
  const response = await instance.post(`api/servicesubmitstep/${payload.flowId}/${payload.step}`, { ...payload.data });
  return response.data
}

export const getAvaliableAuthorizedLocations = async (plateNo) => {
  const response = await instance.get( 
    `api/authorizedlocations/${plateNo}`
  );
  return response.data;
};

export const uploadBodyworkFn = async (payload) => {
  const response = await instance.post(`api/servicesubmitstep/${payload.flowId}/${payload.step}`, payload.data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getServiceLogsFn = async (plateNo) => {
  const response = await instance.get(`api/servicelogs/${plateNo}`);
  return response.data;
};

export const postServiceBookingStepsFn = async (step) => {
  const response = await instance.post(
    `api/servicesubmitstep/{flowId}/${step}`
  );
  return response.data;
};

export const getServiceBookingSummeryFn = async (flowId) => {
  const response = await instance.get(`api/summarypage/${flowId}`);
  return response.data;
};

export const getCarIconsFn =  async () => {
  const response = await instance.get(`api/car-icons`);
  return response.data;
};

export const postCarIconsFn =  async (carIcons) => {
  const response = await instance.post(`api/car-icons`, { icons: carIcons });
  return response.data;
};

